import { Link } from "gatsby"
///
import PropTypes from "prop-types"
import React from "react"
// import Layout from "./layout"
// import "./layout.css"
// import Image from "./image"

const Header = ({ siteTitle }) => (
  <header
    style={{
      background: `rebeccapurple`,
      marginBottom: `1.45rem`,
    }}
  >
    {/*<Helmet>
    <link
      href="https://fonts.googleapis.com/css2?family=Oswald:wght@200;300&display=swap"
      rel="stylesheet"
    />
  </Helmet>*/}

    <div
      style={{
        margin: `0 auto`,
        maxWidth: 960,
        padding: `1.45rem 1.0875rem`,
        justifyContent: `space-between`,
        display: `flex`,
        flexDirection: `row-reverse`,
      }}
    >
      <h1 style={{ margin: 0 }}>
        <Link
          to="/"
          style={{
            color: `white`,
            textDecoration: `none`,
          }}
        >
          {siteTitle}
        </Link>
      </h1>
      {/*  <Image
          className="header-image"
          loading="eager"
          style={{ maxWidth: `10px` }}
        />*/}
    </div>
  </header>
)

Header.propTypes = {
  siteTitle: PropTypes.string,
}

Header.defaultProps = {
  siteTitle: ``,
}

export default Header
